// src/components/WhatDATisNot.jsx
import React from "react";

export default function WhatDATisNot() {
  return (
    <section
      className="mt-4 text-gray-300 space-y-4 leading-relaxed text-sm"
      aria-labelledby="what-dat-is-not-heading"
    >
      <h2
        id="what-dat-is-not-heading"
        className="text-lg font-bold text-gray-100 mb-2"
      >
        What DAT is Not
      </h2>
      <ul className="list-disc list-inside space-y-2">
        <li>
          <strong>Dialectical Analysis Theory (DAT)</strong> is <b>not fast</b>.
          Complex processing demands precision. Precision takes time, and DAT
          may take more than 30 seconds to render.
        </li>
        <li>
          <strong>
            DAT is not a chatbot, search engine, or traditional AI.
          </strong>
        </li>
        <li>
          <strong>DAT does not offer answers.</strong> It does not generate
          content, fill in blanks, or make value judgments.
        </li>
        <li>
          <strong>
            DAT is not designed to “prove” or “disprove” arguments, nor to
            replace expert reasoning.
          </strong>{" "}
          It does not adjudicate truth or offer probabilistic forecasts about
          the world.
        </li>
        <li>
          <strong>DAT is not an oracle.</strong> It will not decide what is
          true, correct, ethical, or actionable. Instead, DAT exposes
          contradictions, clarifies hidden assumptions, and traces the
          boundaries of epistemic uncertainty.
        </li>
        <li>
          <strong>
            DAT is not a substitute for human critical thinking—it is a tool to
            sharpen it.
          </strong>
        </li>
      </ul>
    </section>
  );
}
